const publishDate = (date: Date) => {
  return new Date(date).toLocaleDateString('en-US', publishDateOptions)
}

/**
 * The Date is anchored so its UTC day is the authored publish date, so format
 * in UTC: rendering in the viewer's zone rolled the day forward east of UTC+8
 * and disagreed with the server's render. A `ClientOnly` wrapper was added for
 * that in #617 but passed the same value as its fallback, so it never applied.
 */
const publishDateOptions: Intl.DateTimeFormatOptions = {
  year: 'numeric',
  month: 'long',
  day: 'numeric',
  timeZone: 'UTC',
}

// `dateTime` must be ISO 8601, not the formatted string it used to carry.
const machineDate = (date: Date) => date.toISOString().slice(0, 10)

export const PublishDate = ({ date }: { date: Date | null | undefined }) => {
  if (!date || Number.isNaN(date.getTime())) return null

  return <time dateTime={machineDate(date)}>{publishDate(date)}</time>
}
